var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnionIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 16,
    viewBox: "0 0 12 16",
    width: 12,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#314f61"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3 4c-.27614 0-.5.22386-.5.5s.22386.5.5.5h6c.27614 0 .5-.22386.5-.5s-.22386-.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.5 6.5c0-.27614.22386-.5.5-.5h6c.27614 0 .5.22386.5.5s-.22386.5-.5.5h-6c-.27614 0-.5-.22386-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3 8c-.27614 0-.5.22386-.5.5s.22386.5.5.5h6c.27614 0 .5-.22386.5-.5s-.22386-.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3 10c-.27614 0-.5.2239-.5.5s.22386.5.5.5h3c.27614 0 .5-.2239.5-.5s-.22386-.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 2c0-1.10457.895431-2 2-2h8c1.1046 0 2 .89543 2 2v12c0 1.1046-.8954 2-2 2h-8c-1.104569 0-2-.8954-2-2zm10-1h-8c-.55228 0-1 .44772-1 1v12c0 .5523.44772 1 1 1h8c.5523 0 1-.4477 1-1v-12c0-.55228-.4477-1-1-1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnionIcon);
export default __webpack_public_path__ + "static/media/union-icon.b02e1111853d22c673716dbc72ec7448.svg";
export { ForwardRef as ReactComponent };